/** 会话
state: [{
    id: Number,
    session_type: String, 值：user, group
    ---- session_type: user ----
    jid: String, //对方jid
    name: String, //对方nick_name
    
    ---- session_type: group ----
    jid: String,
    name: String,
    
    unread_count: Number,
    msg_num: Number,
    created_at: Date,
    updated_at: Date,
    last_msg: Object,
    users: [{
        id, jid, name, avatar, status
    }],
    ---- ext ----
    is_active: Boolean,
    status: String, default `offline`,
    avatar: String
}]
*/
import { createAction, createReducer } from 'redux-act';
import _ from 'underscore';
import { genNickName } from '../../utils';

const initialState = [];
const relatedData = {};

function _mapItem(obj) {
    let is_group = obj.session_type === "group";
    obj = _.extend({
        session_type: "user",
        is_active: false,
        users: []
    }, obj);

    if (is_group) {
        obj.name = obj.name || genNickName(obj.users);
    } else {
        let users = obj.users || [];
        let user = _.find(users, (item) => item.jid !== relatedData.user_jid) || _.first(users);
        user && _.extend(obj, _.pick(user, "jid", "avatar", "status"), {
            name: user.nick_name
        });
    }

    return obj;
}

function _addOrEdit(state, obj) {
    let index = _.findIndex(state, { id: obj.id });
    let item = state[index];
    obj = _mapItem(_.extend({}, item, obj));
    item && state.splice(index, 1);
    state.unshift(obj);
    return obj;
}

export const loadRelatedData = createAction('init');
export const add = createAction('add');
export const edit = createAction('edit');
export const addOrEdit = createAction('addOrEdit');
export const remove = createAction('remove');
export const clear = createAction('clear');
export const active = createAction('active');
export const editUser = createAction('editUser');
export const removeUser = createAction('removeUser');

export default createReducer({
    [loadRelatedData]: (state, data) => {
        _.extend(relatedData, data);
        return [...state];
    },

    [add]: (state, obj) => {
        let arr;
        if (_.isArray(obj)) {
            arr = _.map(obj, (item) => {
                return _mapItem(item);
            });
        } else {
            arr = [_mapItem(obj)];
        }

        return [
            ...arr,
            ...state
        ];
    },

    [edit]: (state, obj) => state.map(item => {
        return item.id === obj.id ? _.extend(item, _mapItem(obj)) : item;
    }),

    [addOrEdit]: (state, obj) => {
        if (_.isArray(obj)) {
            _.each(obj, (item) => {
                _addOrEdit(state, item);
            });
        } else {
            obj && _addOrEdit(state, obj);
        }
        return [...state];
    },

    [remove]: (state, id) => state.filter(item =>
        item.id !== id
    ),

    [clear]: (state) => {
        state.length = 0;
        return [...state];
    },

    [active]: (state, id) => state.map(item => {
        item.is_active = (item === id || item.id === id);
        if (item.is_active) {
            item.unread_count = 0;
        }
        return item;
    }),

    [editUser]: (state, user) => state.map(item => {
        let src = _.find(item.users, { jid: user.jid });
        src && (_.extend(src, user));
        return item;
    }),

    [removeUser]: (state, { id, user_jid }) => state.filter(item => {
        return !(item.id === id && _.find(item.users, { jid: user_jid }));
    })
}, initialState);


// WEBPACK FOOTER //
// ./src/session/redux/index.js